export const MAIN_DETAILS_PREFIX = "MainDetails";

export const MAIN_DETAILS_CLASSES = {
  card: `${MAIN_DETAILS_PREFIX}-card`,
  map: `${MAIN_DETAILS_PREFIX}-map`,
  info: `${MAIN_DETAILS_PREFIX}-info`,
  infoTitle: `${MAIN_DETAILS_PREFIX}-infoTitle`,
  clickAndCollectTrialStoreTag: `${MAIN_DETAILS_PREFIX}-clickAndCollectTrialStoreTag`,
  infoLabel: `${MAIN_DETAILS_PREFIX}-infoLabel`,
  infoText: `${MAIN_DETAILS_PREFIX}-infoText`,
  button: `${MAIN_DETAILS_PREFIX}-button`,
  details: `${MAIN_DETAILS_PREFIX}-details`,
  detailsLabel: `${MAIN_DETAILS_PREFIX}-detailsLabel`,
  detailsText: `${MAIN_DETAILS_PREFIX}-detailsText`,
  detailsTextLink: `${MAIN_DETAILS_PREFIX}-detailsTextLink`,
  hours: `${MAIN_DETAILS_PREFIX}-hours`,
  hoursText: `${MAIN_DETAILS_PREFIX}-hoursText`,
  hoursCurrent: `${MAIN_DETAILS_PREFIX}-hoursCurrent`,
  hoursSpecial: `${MAIN_DETAILS_PREFIX}-hoursSpecial`,
  hoursSpecialText: `${MAIN_DETAILS_PREFIX}-hoursSpecialText`,
  link: `${MAIN_DETAILS_PREFIX}-link`,
  linkText: `${MAIN_DETAILS_PREFIX}-linkText`,
  breadcrumbs: `${MAIN_DETAILS_PREFIX}-breadcrumbs`,
  hideOnMobile: `${MAIN_DETAILS_PREFIX}-hideOnMobile`,
};
